import React from 'react'
import Scroll from 'react-scroll'
import PropTypes from 'prop-types'
import ReactPagination from 'react-js-pagination'

import TextareaField from 'Pods/Shared/TextareaField'
import { RuleRunner, run } from '../RuleRunner'
import { required } from '../Rules/Rules'

import Comment from './Components/Comment'

const fieldValidations = [
  RuleRunner('content', 'Content', required),
]

class Comments extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      comments: props.data.data,
      meta: props.data.meta,
      comment: { content: '', id: null, parentId: null },
      showErrors: false,
      disableButton: false,
      isSignedIn: false,
      isAdmin: false,
    }

    this.commentBoxRef = React.createRef()

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.onPaginate = this.onPaginate.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.removeComment = this.removeComment.bind(this)
    this.scrollToCommentBox = this.scrollToCommentBox.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.setState({
      validationErrors: run(this.state.comment, fieldValidations),
      isSignedIn: App.config.userSignedIn,
      isAdmin: App.config.isAdmin || false,
      currentUserId: App.config.userId,
    })
  }

  onPaginate(pageNumber) {
    axios.get(`/api/internal/items/${this.props.itemId}/comments`, { params: { page: pageNumber } })
      .then(this.onFetchSuccess)
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    this.setState({ comments: response.data.data, meta: response.data.meta })
  }

  handleInputChange(event) {
    const newState = this.state

    newState.comment.content = event.target.value
    newState.validationErrors = run(newState.comment, fieldValidations)

    this.setState({ newState })
  }

  handleSubmit(event) {
    event.preventDefault()

    this.setState({
      showErrors: true,
      disableButton: true,
      validationErrors: run(this.state.comment, fieldValidations),
    })

    if (this.state.isSignedIn) {
      if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
        axios.post('/api/internal/comments',
          {
            commentable_type: 'Item',
            commentable_id: this.props.itemId,
            content: this.state.comment.content,
            parent_id: this.state.comment.parentId,
          }).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
      } else {
        this.setState({ disableButton: false })
      }
    } else {
      App.events.publish('app:login:open')
    }
  }

  onSubmitSuccess() {
    const newState = this.state

    newState.comment = { content: '', id: null, parentId: null }

    this.setState(newState)

    this.onPaginate(this.state.meta.currentPage)
  }

  onSubmitFailure(xhr) {
    App.events.publish('app:notification:flash:error', xhr.response.data.errors[0].detail)

    this.setState({ disableButton: false })
  }

  errorFor(field) {
    if (this.state.validationErrors) {
      return this.state.validationErrors[field] || ''
    }
  }

  removeComment(commentId) {
    axios.delete(`/api/internal/comments/${commentId}`)
      .then(this.onSubmitSuccess).catch(this.onSubmitFailure)
  }

  scrollToCommentBox() {
    const rect = this.commentBoxRef.current.getBoundingClientRect()

    Scroll.animateScroll.scrollTo(rect.top)
  }

  render() {
    return (
      <section className="product-comments">
        <div className="u-text-right">
          <button className="btn btn-primary" type="button" onClick={this.scrollToCommentBox}>Write a comment</button>
        </div>

        <ul className="comments-list">
          {this.state.comments.map((comment) => (
            <Comment
              comment={comment.attributes}
              children={comment.attributes.children.data}
              key={comment.id}
              removeComment={this.removeComment}
              isAdmin={this.state.isAdmin}
              onPaginate={this.onPaginate}
              currentPage={this.state.meta.currentPage}
              currentUserId={this.state.currentUserId}
              isSignedIn={this.state.isSignedIn}
              itemId={this.props.itemId}
              depth={1}
            />
          ))}
        </ul>

        {this.state.meta.totalItemsCount > this.state.meta.perPage && (
          <ReactPagination
            activePage={this.state.meta.currentPage}
            itemsCountPerPage={this.state.meta.perPage}
            totalItemsCount={this.state.meta.totalItemsCount}
            pageRangeDisplayed={5}
            onChange={this.onPaginate}
            firstPageText="First"
            lastPageText="Last"
            innerClass="pagination--grey u-text-right"
            disabledClass="is-disabled"
            activeLinkClass="is-active"
          />
        )}

        <form className="comment-form u-mt10" onSubmit={this.handleSubmit}>
          <TextareaField
            label="Your comment"
            required
            id="content"
            name="content"
            errorText={this.errorFor('content')}
            showError={this.state.showErrors}
            value={this.state.comment.content}
            formClassName="form-group-grey"
            inputClassName="form-control-grey"
            onChange={this.handleInputChange}
          />
          <div className="u-text-right" ref={this.commentBoxRef}>
            <button className="btn btn-primary">Post comment</button>
          </div>
        </form>
      </section>
    )
  }
}

Comments.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.object,
  }).isRequired,
  itemId: PropTypes.number.isRequired,
}

export default Comments
